import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import LoadingSpinner from '../common/LoadingSpinner';

function ProtectedRoute({ children }) {
  const { isAuthenticated, loading } = useAuth();

  // Check localStorage as a fallback (for OAuth flow where AuthContext might not be updated yet)
  const hasToken = localStorage.getItem('authToken');
  const hasUser = localStorage.getItem('user');

  if (loading) {
    return <LoadingSpinner />;
  }

  // If not authenticated in context but we have token in localStorage, wait a bit for context to update
  if (!isAuthenticated && hasToken && hasUser) {
    // Give AuthContext a moment to load from localStorage
    return <LoadingSpinner message="Loading..." />;
  }

  if (!isAuthenticated && !hasToken) {
    return <Navigate to="/login" replace />;
  }

  return children;
}

export default ProtectedRoute;














